import { RnAngry, RnHappy, RnMad, RnNeutral, RnStoked } from "@remi/icons/next";

const SENTIMENT_SCORE_RANGES = {
  VERY_POSITIVE: { min: 81, icon: RnStoked },
  POSITIVE: { min: 61, icon: RnHappy },
  NEUTRAL: { min: 41, icon: RnNeutral },
  NEGATIVE: { min: 21, icon: RnMad },
  VERY_NEGATIVE: { min: 0, icon: RnAngry },
} as const;

interface HomeownerSentimentIconProps {
  score: number | null | undefined;
}

export const getSentimentIcon = ({ score }: HomeownerSentimentIconProps): React.JSX.Element | null => {
  if (score === null || score === undefined) {
    return null;
  }
  const sentiment = Object.values(SENTIMENT_SCORE_RANGES).find((range) => score >= range.min);
  if (!sentiment) {
    return null;
  }
  const Icon = sentiment.icon;
  return <Icon />;
};

export const formatSentimentScore = (score: number | null | undefined): string => {
  if (score === null || score === undefined) {
    return "";
  }
  return `${Math.round(score / 10)}/10`;
};

export const SENTIMENT_RANGES = [
  { label: "0-2", value: "0-2", scoreForIcon: 10 },
  { label: "3-4", value: "3-4", scoreForIcon: 35 },
  { label: "5-6", value: "5-6", scoreForIcon: 55 },
  { label: "7-8", value: "7-8", scoreForIcon: 75 },
  { label: "9-10", value: "9-10", scoreForIcon: 95 },
];
